import { EntityTileProps } from '../../../tiles/interfaces/tile';
import { DestinationType } from '../../../shared/interfaces/destination';

export function DestinationTilesFactory(
  sourceTypes: DestinationType[]
): EntityTileProps<DestinationType>[] {
  return sourceTypes.map(sourceType => ({
    id: sourceType.id,
    thumbnail: sourceType.logo,
    darkModeThumbnail: sourceType.logoDarkMode,
    title: sourceType.displayName,
    subtitle: sourceType.version,
    data: { ...sourceType }
  }));
}
